/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseErrorUnauthorizedAllOfError
 */
export interface ResponseErrorUnauthorizedAllOfError {
    /**
     * 
     * @type {string}
     * @memberof ResponseErrorUnauthorizedAllOfError
     */
    code: ResponseErrorUnauthorizedAllOfErrorCodeEnum;
}


/**
 * @export
 */
export const ResponseErrorUnauthorizedAllOfErrorCodeEnum = {
    Unauthorized: 'unauthorized'
} as const;
export type ResponseErrorUnauthorizedAllOfErrorCodeEnum = typeof ResponseErrorUnauthorizedAllOfErrorCodeEnum[keyof typeof ResponseErrorUnauthorizedAllOfErrorCodeEnum];


/**
 * Check if a given object implements the ResponseErrorUnauthorizedAllOfError interface.
 */
export function instanceOfResponseErrorUnauthorizedAllOfError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function ResponseErrorUnauthorizedAllOfErrorFromJSON(json: any): ResponseErrorUnauthorizedAllOfError {
    return ResponseErrorUnauthorizedAllOfErrorFromJSONTyped(json, false);
}

export function ResponseErrorUnauthorizedAllOfErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseErrorUnauthorizedAllOfError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function ResponseErrorUnauthorizedAllOfErrorToJSON(value?: ResponseErrorUnauthorizedAllOfError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

